"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShare = useShare;
const vue_demi_1 = require("vue-demi");
const poster_1 = require("../poster");
const api_1 = require("./api");
const { useUser } = require('@fegobull/webapi').use;
const { isLogin } = useUser();
/**
 * 创建邀请链接二维码
 *
 * @param {string} url 邀请链接
 * @returns {*}  {Promise<string>} 返回二维码的Data URL
 */
async function getQrcode(url) {
    const Qr = await Promise.resolve().then(() => __importStar(require('qrcode')));
    const data = await Qr.toDataURL(url, {
        margin: 0,
        scale: 16,
        color: {
            light: '#0000',
            dark: '#000'
        }
    });
    return data;
}
/**
 * 使用分享
 * @param props 含 shareConfig、poster、可选 nickColor（昵称在海报上的颜色）
 */
function useShare(props) {
    const state = (0, vue_demi_1.reactive)({
        shareUrl: '',
        userInfo: null,
        qrCode: '',
        poster: ''
    });
    /** 在已有分享数据时按当前 poster / nickColor 生成海报 */
    async function applyPoster() {
        if (!props.poster) {
            state.poster = '';
            return;
        }
        const userInfo = state.userInfo;
        if (!state.shareUrl || !state.qrCode || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.nickname) || !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatar)) {
            return;
        }
        state.poster = await (0, poster_1.createPoster)({
            qrCode: state.qrCode,
            nick: userInfo.nickname,
            avatar: userInfo.avatar,
            poster: props.poster,
            uid: userInfo.uid,
            nickColor: props.nickColor
        });
    }
    (0, vue_demi_1.onMounted)(async () => {
        if (!isLogin) {
            return;
        }
        const [shareUrl, userInfo] = await Promise.all([(0, api_1.getShareData)(props.shareConfig), (0, api_1.getUserInfo)()]);
        if (shareUrl) {
            state.qrCode = await getQrcode(shareUrl);
        }
        state.shareUrl = shareUrl;
        state.userInfo = userInfo;
        await applyPoster();
    });
    (0, vue_demi_1.watch)(() => [props.poster, props.nickColor], () => {
        void applyPoster();
    });
    return {
        state
    };
}
//# sourceMappingURL=data:application/json;base64,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